<template>

    <mw-dialog  size="mini_mini" :footerButton="btns" ref="zgDeptDialog" :close-on-click-modal="false">
        <div style="margin-top:20px">
          <el-radio-group v-model="check" >

            <el-radio
              v-for="i in list"
              :label="i.name"
              :key="i.id"
              style="display: block;margin-left: 50px;height: 30px;line-height:30px;font-size: 16px;font-weight: normal">{{i.name}}</el-radio>

          </el-radio-group>

        </div>
       
    </mw-dialog>

</template>
<script>
  export default {
    data() {
      return {
        btns: [{
              label: '取消',
              func: this.cancelLevel,
              type: 'default'
            },{
              label: '确定',
              func: this.confirmLevel
        }],
        check: '',
        list: [{
          'id': 1,
          'name': '第一级用户'
        }, {'id': 2, 'name': '第二级用户'},
          {'id': 3, 'name': '第三级用户'},
          {'id': 4, 'name': '第四级用户'},
          {'id': 5, 'name': '领导级'},
          {'id': 6, 'name': '部门级'}
        ],
      }
    },
    methods:{
      show(){
        this.mwRef('zgDeptDialog').show();
      },
      cancelLevel(){
        this.mwRef('zgDeptDialog').hide();
      },
      confirmLevel(){
        this.$emit("confirm",this.check);
        this.cancelLevel();
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/staffLevel.vue